import { NgFor, NgIf } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { StoryblokComponentInstance, StoryblokService } from 'src/app/services/storyblok.service';
import { NotFoundComponent } from 'src/app/shared/components/not-found/not-found.component';
import { WebsiteFooterComponent } from 'src/app/shared/components/website-footer/website-footer.component';
import { WebsiteHeaderComponent } from 'src/app/shared/components/website-header/website-header.component';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokCta, StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { PreFooterComponent } from '../pre-footer/pre-footer.component';
import { TopGradientComponent } from '../top-gradient/top-gradient.component';

@Component({
  selector: 'app-storyblok-root',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    StoryblokDirective,
    DynamicComponent,
    DynamicIoDirective,
    WebsiteHeaderComponent,
    PreFooterComponent,
    RouterLink,
    ButtonDirective,
    WebsiteFooterComponent,
    NotFoundComponent,
    TopGradientComponent,
    StoryblokCdnPipe,
  ],
  templateUrl: './storyblok-root.component.html',
  styleUrls: ['./storyblok-root.component.scss'],
})
export class StoryblokRootComponent {
  @Input({ required: true }) story: ISbStoryData;
  @Input({ required: true }) darkHeader: boolean;
  @Input({ required: true }) prefooter: {
    cta: StoryblokCta[];
    _uid: string;
    image: StoryblokImage;
    component: 'preFooter';
    _editable: string;
  };
  @Input({ required: true }) hasHomeTeaser: boolean;
  @Input({ required: true }) blurOverlay: StoryblokImage;
  @Input({ required: true }) topBlur: StoryblokImage;
  @Input({ required: true }) verticalDottedLines: boolean;
  @Input() replacer: (key: string) => string;
  @Input() extraDataMap: Map<string, { [key: string]: unknown }>;
  @Input() hideHeaderNav: boolean;
  @Input() customCta: 'contact' | undefined;

  public storyblokService = inject(StoryblokService);

  trackByFunction(index: number, item: StoryblokComponentInstance) {
    return item._uid;
  }

  dynamicInputs(values: { [key: string]: unknown }) {
    const data = { ...values, replacer: this.replacer };
    const extraData = this.extraDataMap?.get((values as { component: string }).component);
    if (extraData) {
      for (const key of Object.keys(extraData)) data[key] = extraData[key];
    }
    return data;
  }
}
